
import Vue from 'vue';
import Component from 'vue-class-component';
import apiClient from '../../clients/api-client';
import TButton from '@/lib/form/button/Button.vue';
import TubeLabel from '@/lib/form/label/Label.vue';
import logger from '@/app/logger';
import TInput from '@/lib/form/input/Input.vue';
import { AuthService } from '@/app/services/auth-service';
import WorkspaceUtils from '@/app/utils/workspace-utils';

@Component({
  name: 'invite-team-members',
  props: ['mode', 'context'],
  components: {
    TInput,
    TButton,
    TubeLabel
  }
})
export default class InviteTeamMembers extends Vue {
  private email = '';
  private emails: any[] = [];
  private invalidEmails = false;
  private loader = false;

  get workspaceName() {
    return AuthService.getInstance().getWorkspaceName();
  }

  pushEmail() {
    this.emails.push({
      value: this.email,
      error: this.validateEmail(this.email)
    });
    this.email = '';
  }

  keydown(event) {
    this.invalidEmails = false;
    if (event.key !== ',' && event.key !== ' ' && event.key !== 'Enter') {
      return;
    }
    event.preventDefault();
    this.pushEmail();
  }

  remove(index) {
    this.emails.splice(index, 1);
  }

  validateEmail(email) {
    if (
      !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i.test(
        email
      )
    ) {
      return `wrong format`;
    }
  }

  invite() {
    this.invalidEmails = false;

    if (this.email !== '') {
      this.pushEmail();
    }

    if (
      this.$isEmpty(this.emails) ||
      !this.$isEmpty(this.emails.filter(e => e.error))
    ) {
      this.invalidEmails = true;
      return;
    }
    this.loader = true;
    // vivek
    apiClient
      .inviteBulk(
        this.emails.map(e => e.value),
        'creator'
      )
      .then(data => {
        this.redirect();
      })
      .catch(e => {
        this.loader = false;
        this.$error(e);
      });
  }

  redirect() {
    window.location.href = `${WorkspaceUtils.getCommonUrl()}/library`;
  }
}
